import { render, staticRenderFns } from "./Menu404.vue?vue&type=template&id=68ad7029&scoped=true&"
var script = {}
import style0 from "./Menu404.vue?vue&type=style&index=0&id=68ad7029&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ad7029",
  null
  
)

export default component.exports